export const GET_PAYMENT_INTENT = "STRIPE_PAYMENT/GET_PAYMENT_INTENT";
export const GET_PAYMENT_INTENT_SUCCESS = "STRIPE_PAYMENT/GET_PAYMENT_INTENT_SUCCESS";
export const GET_PAYMENT_INTENT_FAILED = "STRIPE_PAYMENT/GET_PAYMENT_INTENT_FAILED";
